import React, { ReactNode } from 'react';
import { Select } from 'antd';

type SelectMultiTypeNameProps = {
  value?: string[];
  disabled?: boolean;
  onChange?: (values: string[]) => void;
};

const { Option } = Select;

const SelectMultiTypeName: React.FC<SelectMultiTypeNameProps> = (props) => {
  const { value, disabled, onChange } = props;
  const options = [
    {
      label: 'Stock site',
      value: '1',
    },
    {
      label: 'Hub',
      value: '2',
    },
    {
      label: 'Last mile',
      value: '3',
    },
  ];

  const renderOptions: ReactNode[] = options.map((item) => {
    return <Option key={item.value} value={item.value}>{`${item.label}`}</Option>;
  });

  return (
    <Select
      allowClear
      mode="multiple"
      maxTagCount="responsive"
      value={value}
      disabled={disabled}
      placeholder="ค้นหา"
      onChange={(valueChange) => {
        onChange && onChange(valueChange);
      }}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={{ width: '100%' }}
    >
      {renderOptions}
    </Select>
  );
};

export default SelectMultiTypeName;
